const getDatesForDayOfWeek = (chosenDay: Date, dayAhead: Date) => {
  const datesForDayOfWeek = [];
  let currentCheckDay = new Date(chosenDay);
  while (currentCheckDay <= dayAhead) {
    if (currentCheckDay.getDay() === chosenDay.getDay()) {
      datesForDayOfWeek.push(new Date(currentCheckDay));
    }
    currentCheckDay.setDate(currentCheckDay.getDate() + 7);
  }
  return datesForDayOfWeek;
};

export interface SelectedTables {
  // timeblockId:tableId
  [key: number]: number;
}
export const getReservationsForYear = (
  chosenDay: Date,
  dayAhead: Date,
  selectedTables: SelectedTables,
  userId: number,
  placeId: number,
) => {
  const reservationsForYear = [];
  const dayOfWeekDates = getDatesForDayOfWeek(chosenDay, dayAhead);
  for (const dateOfWeek of dayOfWeekDates) {
    for (const [blockId, tableId] of Object.entries(selectedTables)) {
      reservationsForYear.push({
        id: Number(blockId),
        user_id: userId,
        place_id: placeId,
        table_id: tableId,
        day: dateOfWeek.toLocaleDateString('ru-RU'),
      });
    }
  }
  return reservationsForYear;
};

export const getDaysForYear = (chosenDay: Date, dayAhead: Date) => {
  const daysForYear = [];
  const dayOfWeekDates = getDatesForDayOfWeek(chosenDay, dayAhead);
  for (const dateOfWeek of dayOfWeekDates) {
    daysForYear.push({
      day: dateOfWeek.toLocaleDateString('ru-RU'),
    });
  }

  return daysForYear;
};
